// @ts-nocheck
/* eslint-disable */
Mapy.ContextMenu = function() {
	SMap.Control.ContextMenu.call(this);
}

Mapy.ContextMenu.prototype = Object.create(Object.assign({}, SMap.Control.prototype, SMap.Control.ContextMenu.prototype));

Mapy.ContextMenu.prototype.open = function(event, coords) {
	SMap.Control.ContextMenu.prototype.open.call(this, event, coords);
	document.addEventListener("keydown", this, false);

	// ribbon - klikatko
	if (Mapy.CUS.ribbon?.enabled || Mapy.CUS.userweb?.ribbon) {
		this._dom.container.classList.add("ribbon-enabled");
	}
};

Mapy.ContextMenu.prototype.close = function() {
	if (!this._isOpen) { return; }
	document.removeEventListener("keydown", this, false);
	SMap.Control.ContextMenu.prototype.close.call(this);
};

Mapy.ContextMenu.prototype.handleEvent = function(e) {
	if (e.type != "keydown") return;

	var keyCode = e.which || e.keyCode;

	if (keyCode == 27) {
		this.close();
		e.stopPropagation();
	}
};
